import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";
import fonts from "styles/fonts";

export const SpinnerSection = styled.div`
  height: 500px;
`;

export const SubsectionHeader = styled.h2`
  color: ${colours.elexonBlack};
  margin-top: 2rem;
`;

export const LandingSection = styled.section`
  padding-top: 2rem;
  padding-bottom: 2rem;
`;

export const RequestSecretButton = styled.button`
  ${resetButtonStyling};
  color: black;
`;

export const RequestCredentialsButtonContainer = styled.div`
  margin-top: 1.5rem;
`;

export const ClientDetailsContainer = styled.div`
  padding-bottom: 2em;
`;

export const InfoBoxContainer = styled.div`
  margin-left: 1em;
`;

export const StyledCancelButton = styled(Button)`
  && {
    background: transparent;
    color: ${colours.elexonBlue};
    border: 1px solid ${colours.elexonBlue};
    box-shadow: unset;
    padding: 0.6rem 1.9rem;
    height: 2.5rem;
    transition: all 0.3s;

    &&:hover {
      background-color: ${colours.elexonBlue};
      color: ${colours.white};
    }
  }
`;

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: center;
  gap: 3em;
`;

export const ContentContainer = styled.div`
  margin-top: 0.75em;
  margin-left: 5em;
  margin-right: 5em;
  text-align: center;
  justify-content: space-around;
  padding: 1em;

  > h2 {
    margin-bottom: 1em;
  }

  > p {
    padding-left: 2.5em;
    padding-right: 2.5em;
  }
`;

export const ContentDiv = styled.div`
  font-size: ${fonts.smallMedium};
  margin-left: 1em;
`;
